import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { componentLoader } from 'utils/componentLoader';

const Footer = lazy(() => componentLoader(() => import(/* webpackChunkName: "footer" */ 'components/layout/Footer')));

const FooterLayout = ({ children, withDownloadsSection, withSubScenery }) => (
  <>
    {children}
    <Footer withDownloadsSection={withDownloadsSection} withSubScenery={withSubScenery} />
  </>
);

FooterLayout.propTypes = {
  children: PropTypes.node.isRequired,
  withDownloadsSection: PropTypes.bool.isRequired,
  withSubScenery: PropTypes.bool.isRequired,
};

export default FooterLayout;
